import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_branch_list = createAsyncThunk(
  "get_branch_list",
  async (id) => {
    const body = new FormData();
    body.append("userid", id);
    const responce = await fetch(baseUrl + "branch-list", {
      method: "POST",
      body: body,
    });
    const res = await responce.json();
    // console.log(res);
    return res;
  }
);

const branchlistSlice = createSlice({
  name: "branchlist",
  initialState: {
    branch_list: [],
    b_loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(get_branch_list.pending, (state, action) => {
      state.b_loading = true;
    });
    builder.addCase(get_branch_list.rejected, (state, action) => {
      state.b_loading = false;
    });
    builder.addCase(get_branch_list.fulfilled, (state, action) => {
      state.b_loading = false;
      const data = action.payload;
      if (data.status == 0) {
        state.branch_list = data.reponselist;
      } else {
        state.branch_list = [];
      }
    });
  },
});
export default branchlistSlice.reducer;
